import React from 'react';
import Svg, { Line, Path } from 'react-native-svg';

type NewsIconProps = {
  color: string;
};

/**
 * Newspaper outline: a page with a folded right edge and the headline lines
 * on the left. Used by the news button on the map.
 */
const NewsIcon = ({ color }: NewsIconProps) => {
  return (
    <Svg width={20} height={20} viewBox="0 0 24 24" fill="none">
      <Path
        d="M19 20H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v12a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-2"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Line
        x1={7}
        y1={8}
        x2={14}
        y2={8}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
      <Line
        x1={7}
        y1={12}
        x2={14}
        y2={12}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
      <Line
        x1={7}
        y1={16}
        x2={11}
        y2={16}
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </Svg>
  );
};

export default NewsIcon;
